import { buildEventLink } from '@/lib/navigation/routes';

type CalendarEvent = {
  id: string;
  title: string;
  starts_at: string;
  ends_at?: string | null;
  venue_name?: string | null;
  address?: string | null;
  description?: string | null;
};

export function getCalendarEventEnd(event: Pick<CalendarEvent, 'starts_at' | 'ends_at'>) {
  if (event.ends_at) {
    return new Date(event.ends_at);
  }
  // Calendar exports need a concrete end time even when Radious only knows the start.
  return new Date(new Date(event.starts_at).getTime() + 4 * 60 * 60 * 1000);
}

function formatCalendarURLTimestamp(value: Date) {
  return value
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');
}

export function buildGoogleCalendarURL(event: CalendarEvent) {
  const start = new Date(event.starts_at);
  const end = getCalendarEventEnd(event);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${formatCalendarURLTimestamp(start)}/${formatCalendarURLTimestamp(end)}`,
    details: [event.description, `On Radious: ${buildEventLink(event.id, event.title)}`]
      .filter(Boolean)
      .join('\n\n'),
    location: [event.venue_name, event.address].filter(Boolean).join(', '),
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
